var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9885 25.33C15.9178 25.33 14.9645 25.1137 14.1285 24.681C13.2998 24.241 12.6472 23.6397 12.1705 22.877C11.7012 22.107 11.4665 21.2307 11.4665 20.248C11.4665 19.412 11.6535 18.6237 12.0275 17.883C12.4088 17.1423 12.9552 16.5373 13.6665 16.068L13.6005 16.992C13.0652 16.4713 12.6435 15.9213 12.3355 15.342C12.0348 14.7627 11.8845 14.11 11.8845 13.384C11.8845 12.4673 12.1008 11.668 12.5335 10.986C12.9735 10.304 13.5748 9.776 14.3375 9.402C15.1075 9.02067 15.9912 8.83 16.9885 8.83C17.9858 8.83 18.8658 9.02067 19.6285 9.402C20.3985 9.776 20.9998 10.304 21.4325 10.986C21.8725 11.668 22.0925 12.4673 22.0925 13.384C22.0925 14.11 21.9495 14.7627 21.6635 15.342C21.3775 15.914 20.9412 16.4713 20.3545 17.014V16.09C21.0512 16.53 21.5865 17.124 21.9605 17.872C22.3418 18.62 22.5325 19.412 22.5325 20.248C22.5325 21.2307 22.2942 22.107 21.8175 22.877C21.3408 23.6397 20.6845 24.241 19.8485 24.681C19.0125 25.1137 18.0592 25.33 16.9885 25.33ZM16.9885 22.514C17.6925 22.514 18.2645 22.3233 18.7045 21.942C19.1445 21.5607 19.3645 20.996 19.3645 20.248C19.3645 19.5073 19.1445 18.9427 18.7045 18.554C18.2645 18.158 17.6925 17.96 16.9885 17.96C16.2845 17.96 15.7162 18.158 15.2835 18.554C14.8508 18.9427 14.6345 19.5073 14.6345 20.248C14.6345 20.996 14.8508 21.5607 15.2835 21.942C15.7162 22.3233 16.2845 22.514 16.9885 22.514ZM16.9885 15.122C17.5605 15.122 18.0262 14.9827 18.3855 14.704C18.7448 14.418 18.9245 13.978 18.9245 13.384C18.9245 12.79 18.7448 12.35 18.3855 12.064C18.0262 11.7707 17.5605 11.624 16.9885 11.624C16.4165 11.624 15.9508 11.7707 15.5915 12.064C15.2322 12.35 15.0525 12.79 15.0525 13.384C15.0525 13.978 15.2322 14.418 15.5915 14.704C15.9508 14.9827 16.4165 15.122 16.9885 15.122Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8H);
export default __webpack_public_path__ + "static/media/8h.9aeb30fc31681d16ab813d260a2716ab.svg";
export { ForwardRef as ReactComponent };